import { render, staticRenderFns } from "./TaskFilters.vue?vue&type=template&id=6ee8bb24&"
import script from "./TaskFilters.vue?vue&type=script&lang=ts&"
export * from "./TaskFilters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports